import React from 'react';
import { string, shape } from 'prop-types';
import { Field } from 'redux-form';
import Radium from 'radium';
import { WithLoading } from '@widergy/energy-ui';

import { accountsPropTypes } from 'types/accountTypes';

import UTCheckList from '../../../../components/UTCheckList';
import { message } from '../../../../../utils/stringUtils';

import styles from './styles';

const header = [{ text: message('Signup:accountNumber') }, { text: message('Commons:address') }];

const ACCOUNT_LIST = 'accountList';

const ServiceAdherence = props => (
  <div style={styles.form}>
    <div style={styles.termsContainer}>
      <div
        dangerouslySetInnerHTML={props.termsOfService} // eslint-disable-line react/no-danger
        style={styles.terms}
      />
    </div>
    <div style={styles.accounts}>
      <Field
        name={ACCOUNT_LIST}
        list={props.accounts}
        component={UTCheckList}
        header={header}
        checked
        withoutLabel
      />
    </div>
  </div>
);

ServiceAdherence.propTypes = {
  termsOfService: shape({
    __html: string
  }),
  accounts: accountsPropTypes
};

export default WithLoading(props => props.loading)(Radium(ServiceAdherence));
